import React from 'react';
import {
    Grid,
    Typography,
    TextField,
    Button,
    DialogContent,
    MenuItem,
    FormControlLabel,
    Checkbox,
} from '@mui/material';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import DraggableDialog from '../../../ui/draggableDialog';
import { toast } from 'react-toastify';
import { isLocalDev } from '../../../../utils/environment';
import { LensConfigurationService } from '../../../../service/validDataService';
import { initialValuesLensTreatmentForm } from './validLensTreatmentInputForm';

const treatmentCategories = [
    { value: 'coating', label: 'Coating' },
    { value: 'tint', label: 'Tint' },
    { value: 'photochromic', label: 'Photochromic' },
    { value: 'polarization', label: 'Polarization' },
    { value: 'uv-protection', label: 'UV Protection' },
    { value: 'other', label: 'Other' },
];

export default function EditValidLensTreatmentForm({ open, onClose, onRecordEdit, recordToEdit, isCopy = false }) {

    const handleSubmit = async (values, { resetForm }) => {
        try {
            let response;

            if (isCopy) {
                const { id, ...newValues } = values;
                response = await LensConfigurationService.addTreatment(newValues);
            } else {
                response = await LensConfigurationService.updateTreatment(values);
            }
            
            const { code, data, message } = response;
            if (code === 0) {
                toast.success(message);
                onClose();
                onRecordEdit(data);
            } else {
                toast.error(message);
            }
        } catch (error) {
            if (isLocalDev) {
                console.log(error);
            }
            toast.error('Failed to update lens treatment');
        }
    };

    return (
        <DraggableDialog title={isCopy ? "Copy Lens Treatment" : "Edit Lens Treatment"} onClose={onClose} open={open} width={'sm'}>
            <DialogContent sx={{ mt: 1, mb: 1 }}>
                <Formik
                    initialValues={{ ...initialValuesLensTreatmentForm, ...recordToEdit }}
                    onSubmit={handleSubmit}
                >
                    {({ isSubmitting, values, setFieldValue }) => (
                        <Form>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Field
                                        as={TextField}
                                        name="name"
                                        label="Treatment Name"
                                        required
                                        fullWidth
                                        size="small"
                                    />
                                    <ErrorMessage name="name">{message => <Typography color={'red'}>{message}</Typography>}</ErrorMessage>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Field
                                        as={TextField}
                                        name="category"
                                        label="Category"
                                        required
                                        fullWidth
                                        select
                                        size="small"
                                    >
                                        {treatmentCategories.map((cat) => (
                                            <MenuItem key={cat.value} value={cat.value}>
                                                {cat.label}
                                            </MenuItem>
                                        ))}
                                    </Field>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Field
                                        as={TextField}
                                        name='status'
                                        label="Status"
                                        fullWidth
                                        select
                                        size="small"
                                    >
                                        <MenuItem value={"active"}>Active</MenuItem>
                                        <MenuItem value={"inactive"}>Inactive</MenuItem>
                                    </Field>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Field
                                        as={TextField}
                                        name="cost"
                                        label="Cost"
                                        type="number"
                                        fullWidth
                                        size="small"
                                        inputProps={{ step: "0.01" }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Field
                                        as={TextField}
                                        name="retailPrice"
                                        label="Retail Price"
                                        type="number"
                                        fullWidth
                                        size="small"
                                        inputProps={{ step: "0.01" }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={values.isStackable}
                                                onChange={(e) => setFieldValue('isStackable', e.target.checked)}
                                                name="isStackable"
                                            />
                                        }
                                        label="Stackable (can be combined with other treatments)"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Field
                                        as={TextField}
                                        name="notes"
                                        label="Notes"
                                        multiline
                                        rows={2}
                                        fullWidth
                                        size="small"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        disabled={isSubmitting}
                                    >
                                        {isCopy ? 'Create Copy' : 'Update'}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Form>
                    )}
                </Formik>
            </DialogContent>
        </DraggableDialog>
    );
};
